import React, { useEffect, useMemo, useRef } from 'react';
import { X } from 'lucide-react';
import { unmappedTechsForBanner } from './simulatorRawTechMapping';

const AUTO_HIDE_MS = 3000;

function formatBannerMessage(items) {
  const parts = items.map((u) => `${u.gw} GW of '${u.name}'`);
  if (parts.length === 1) {
    return `${parts[0]} could not be mapped and was excluded from the simulation.`;
  }
  if (parts.length === 2) {
    return `${parts[0]} and ${parts[1]} could not be mapped and were excluded from the simulation.`;
  }
  const last = parts.pop();
  return `${parts.join(', ')}, and ${last} could not be mapped and were excluded from the simulation.`;
}

export default function SimulatorUnmappedTechBanner({ unmapped, onDismiss }) {
  const visible = useMemo(() => unmappedTechsForBanner(unmapped), [unmapped]);
  const visibleKey = visible.map((u) => `${u.name}:${u.gw}`).join('|');
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    if (!visibleKey) return undefined;
    const id = setTimeout(() => onDismissRef.current?.(), AUTO_HIDE_MS);
    return () => clearTimeout(id);
  }, [visibleKey]);

  if (visible.length === 0) return null;

  return (
    <div
      className="mx-2 md:mx-4 lg:mx-6 mt-2 mb-0 flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900"
      role="status"
    >
      <p className="flex-1 min-w-0">{formatBannerMessage(visible)}</p>
      <button
        type="button"
        onClick={onDismiss}
        className="flex-shrink-0 p-1 rounded hover:bg-amber-100 transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
